export default "__VITE_ASSET__B_jHH7Gf__"